export const locales = ["de", "en", "fr", "zh", "ja"] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "de";

export const localeCookieName = "SL_LOCALE";

/** Request header set by middleware for root layout `lang` */
export const LOCALE_HEADER = "x-sl-locale";

export type LocaleInfo = {
  code: Locale;
  /** Short label for compact UI (e.g. select trigger) */
  shortLabel: string;
  /** Native-language name for the menu */
  label: string;
};

export const localeInfos: readonly LocaleInfo[] = [
  { code: "de", shortLabel: "DE", label: "Deutsch" },
  { code: "en", shortLabel: "EN", label: "English" },
  { code: "fr", shortLabel: "FR", label: "Français" },
  { code: "zh", shortLabel: "CN", label: "中文" },
  { code: "ja", shortLabel: "JA", label: "日本語" },
] as const;

const localeSet = new Set<string>(locales);

export function isLocale(value: string | null | undefined): value is Locale {
  return value != null && localeSet.has(value);
}

/** BCP 47 language tag for <html lang> */
export function localeToHtmlLang(locale: Locale): string {
  switch (locale) {
    case "zh":
      return "zh-Hans";
    default:
      return locale;
  }
}
